import React from 'react';

function FileDefault(props) {
  return (
    <svg height={24} width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M17.6625 8.34375C17.6625 7.99857 17.3827 7.71875 17.0375 7.71875H7.03751L6.94515 7.72553C6.64376 7.77017 6.41251 8.02995 6.41251 8.34375C6.41251 8.68893 6.69233 8.96875 7.03751 8.96875H17.0375L17.1299 8.96197C17.4312 8.91733 17.6625 8.65755 17.6625 8.34375ZM17.0375 11.7656C17.3827 11.7656 17.6625 12.0454 17.6625 12.3906C17.6625 12.7044 17.4312 12.9642 17.1299 13.0088L17.0375 13.0156H7.03751C6.69233 13.0156 6.41251 12.7358 6.41251 12.3906C6.41251 12.0768 6.64376 11.817 6.94515 11.7724L7.03751 11.7656H17.0375ZM12.6625 16.375C12.6625 16.0298 12.3827 15.75 12.0375 15.75H7.03751L6.94515 15.7568C6.64376 15.8014 6.41251 16.0612 6.41251 16.375C6.41251 16.7202 6.69233 17 7.03751 17H12.0375L12.1299 16.9932C12.4312 16.9486 12.6625 16.6888 12.6625 16.375Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M17.0579 3.42286C16.9457 3.31341 16.7893 3.24854 16.625 3.24854H4.875C4.53018 3.24854 4.25 3.52871 4.25 3.87354V20.1235C4.25 20.4684 4.53018 20.7485 4.875 20.7485H19.125C19.4698 20.7485 19.75 20.4684 19.75 20.1235V6.27604C19.75 6.10786 19.6823 5.94732 19.5637 5.83097C19.563 5.83035 19.5624 5.82973 19.5618 5.82911L17.0579 3.42286ZM20.4332 4.93296C20.7957 5.28544 21 5.77031 21 6.27604V20.1235C21 21.1587 20.1602 21.9985 19.125 21.9985H4.875C3.83982 21.9985 3 21.1587 3 20.1235V3.87354C3 2.83836 3.83982 1.99854 4.875 1.99854H16.625C17.1139 1.99854 17.5838 2.18973 17.9306 2.52789L20.4332 4.93296Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default FileDefault;
